var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-youtube"},[(_vm.module && _vm.module.resource && _vm.module.resource.content)?_c('div',{staticClass:"video-container"},[_c('video',{attrs:{"controls":!_vm.autoplay,"width":"100%","height":"100%","autoplay":_vm.autoplay,"loop":_vm.autoplay}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }